import { supabase } from "@/lib/supabase";

export type PublicPlatformStats = {
  partnerAgencies: number;
  availableVehicles: number;
  coveredCities: number;
  verifiedProfiles: number;
};

type PublicPlatformStatsRow = {
  partner_agencies?: number | null;
  available_vehicles?: number | null;
  covered_cities?: number | null;
  verified_profiles?: number | null;
};

const toNonNegativeInt = (value: unknown): number => {
  const parsed = typeof value === "number" ? value : Number(value);
  if (!Number.isFinite(parsed) || parsed < 0) {
    return 0;
  }
  return Math.floor(parsed);
};

export const mapPublicPlatformStats = (row: PublicPlatformStatsRow): PublicPlatformStats => ({
  partnerAgencies: toNonNegativeInt(row.partner_agencies),
  availableVehicles: toNonNegativeInt(row.available_vehicles),
  coveredCities: toNonNegativeInt(row.covered_cities),
  verifiedProfiles: toNonNegativeInt(row.verified_profiles),
});

export const formatStatWithPlus = (count: number): string => {
  if (count <= 0) {
    return "0";
  }
  return `${count}+`;
};

export const fetchPublicPlatformStats = async (): Promise<PublicPlatformStats | null> => {
  const { data, error } = await supabase.rpc("get_public_platform_stats");

  if (error) {
    if (import.meta.env.DEV) {
      console.error("[platformStats] RPC get_public_platform_stats:", error.message);
    }
    return null;
  }

  if (!data || typeof data !== "object") {
    return null;
  }

  return mapPublicPlatformStats(data as PublicPlatformStatsRow);
};
